// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/Images/AboutUsLine.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../Assets/Images/AboutUs.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AboutUs_aboutUs__-5Kcw {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}), url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: auto, cover;
  background-position: center, center;
  background-repeat: no-repeat;
  width: 80%;
  margin: 72px auto;
  height: 1700px;
  filter: drop-shadow(3px 10px 21px rgba(255, 255, 255, 0.25));
  border-radius: 117px;
  color: #ffffff;
}
@media (max-width: 1200px) {
  .AboutUs_aboutUs__-5Kcw {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    background-size: cover;
    border-radius: 25px;
    margin: 0 auto;
  }
}
.AboutUs_aboutUs__-5Kcw .AboutUs_logo__8qXVy {
  background: rgba(255, 255, 255, 0.09);
  border-radius: 52px;
  margin: auto;
  max-width: 400px;
  text-align: center;
  padding: 10px;
}
.AboutUs_aboutUs__-5Kcw .AboutUs_logo__8qXVy img {
  margin-bottom: 30px;
}
.AboutUs_aboutUs__-5Kcw .AboutUs_logo__8qXVy h2, .AboutUs_aboutUs__-5Kcw .AboutUs_logo__8qXVy h1 {
  margin: 0;
  font-family: "hemi_head";
}
.AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ {
  position: relative;
  height: 100%;
}
.AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ p {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  font-family: Roboto;
  max-width: 400px;
  padding: 15px;
}
.AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item1__Rucft {
  position: absolute;
  top: 10%;
  left: 10%;
}
@media (max-width: 1200px) {
  .AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item1__Rucft {
    left: 3%;
  }
}
.AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item2__9xT\\+Y {
  position: absolute;
  top: 25%;
  right: 10%;
}
@media (max-width: 1200px) {
  .AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item2__9xT\\+Y {
    right: 3%;
  }
}
.AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item3__tdwvP {
  position: absolute;
  top: 50%;
  left: 10%;
}
@media (max-width: 1200px) {
  .AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item3__tdwvP {
    left: 3%;
    top: 40%;
  }
}
.AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item4__qKVMf {
  position: absolute;
  top: 60%;
  right: 10%;
}
@media (max-width: 1200px) {
  .AboutUs_aboutUs__-5Kcw .AboutUs_items__vVlP\\+ .AboutUs_item4__qKVMf {
    right: 3%;
    top: 65%;
  }
}
.AboutUs_aboutUs__-5Kcw h3 {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  font-size: 35px;
  text-align: center;
  font-family: hemi_head;
}
@media (max-width: 600px) {
  .AboutUs_aboutUs__-5Kcw h3 {
    font-size: 24px;
    display: none;
  }
}

.AboutUs_itemBlock__G3W8B {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 80%;
  min-height: 600px;
  margin: auto;
  background: rgba(217, 217, 217, 0.09);
  box-shadow: 4px 4px 4px rgba(255, 255, 255, 0.25);
  border-radius: 328px 0px;
  color: #ffffff;
  margin-top: 50px;
  padding: 30px;
  position: relative;
}
@media (max-width: 700px) {
  .AboutUs_itemBlock__G3W8B {
    border-radius: 100px 0px;
  }
}
.AboutUs_itemBlock__G3W8B div {
  text-align: center;
  font-family: Roboto;
  width: 100%;
}
.AboutUs_itemBlock__G3W8B div h4 {
  font-family: hemi_head;
  text-shadow: 3px 3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);
  font-size: 36px;
}
.AboutUs_itemBlock__G3W8B div .AboutUs_text1__Rt-Jq {
  display: flex;
  width: 100%;
}
.AboutUs_itemBlock__G3W8B div .AboutUs_text2__KmGGF {
  display: flex;
  width: 100%;
  justify-content: space-evenly;
}
.AboutUs_itemBlock__G3W8B div p {
  max-width: 400px;
}
.AboutUs_itemBlock__G3W8B .AboutUs_imgBlock__hkmEu {
  width: auto;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(-10%, 10%);
}
@media (max-width: 980px) {
  .AboutUs_itemBlock__G3W8B .AboutUs_imgBlock__hkmEu {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Pages/AboutUs/AboutUs.module.scss"],"names":[],"mappings":"AAAA;EACE,4FAAA;EACA,4BAAA;EACA,mCAAA;EACA,4BAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,4DAAA;EACA,oBAAA;EACA,cAAA;AACF;AAAE;EAXF;IAYI,mDAAA;IACA,sBAAA;IACA,mBAAA;IACA,cAAA;EAGF;AACF;AAFE;EACE,qCAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;AAIJ;AAFI;EACE,mBAAA;AAIN;AADI;EACE,SAAA;EACA,wBAAA;AAGN;AACE;EACE,kBAAA;EACA,YAAA;AACJ;AACI;EACE,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,aAAA;AACN;AAEI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAAN;AACM;EAJF;IAKG,QAAA;EAEL;AACF;AACI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AACN;AAAM;EAJF;IAKI,SAAA;EAGN;AACF;AAAI;EACE,kBAAA;EACA,QAAA;EACA,SAAA;AAEN;AADM;EAJF;IAKI,QAAA;IACA,QAAA;EAIN;AACF;AAFI;EACE,kBAAA;EACA,QAAA;EACA,UAAA;AAIN;AAHM;EAJF;IAKI,SAAA;IACA,QAAA;EAMN;AACF;AAFE;EACE,kBAAA;EACA,SAAA;EACA,SAAA;EACA,2BAAA;EACA,eAAA;EACA,kBAAA;EACA,sBAAA;AAIJ;AAHI;EARF;IASI,eAAA;IACA,aAAA;EAMJ;AACF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;EACA,YAAA;EACA,qCAAA;EACA,iDAAA;EACA,wBAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAMF;AALE;EAdF;IAeI,wBAAA;EAQF;AACF;AAPE;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;AASJ;AARI;EACE,sBAAA;EACA,yFAAA;EACA,eAAA;AAUN;AARI;EACE,aAAA;EACA,WAAA;AAUN;AARI;EACE,aAAA;EACA,WAAA;EACA,6BAAA;AAUN;AAPI;EACE,gBAAA;AASN;AANE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,+BAAA;AAQJ;AAPI;EANF;IAOE,aAAA;EAUF;AACF","sourcesContent":[".aboutUs {\n  background: url(\"../../Assets/Images/AboutUsLine.png\"), url(\"../../Assets/Images/AboutUs.jpg\");\n  background-size: auto, cover;\n  background-position: center, center;\n  background-repeat: no-repeat;\n  width: 80%;\n  margin: 72px auto;\n  height: 1700px;\n  filter: drop-shadow(3px 10px 21px rgba(255, 255, 255, 0.25));\n  border-radius: 117px;\n  color: #ffffff;\n  @media (max-width: 1200px) {\n    background: url(\"../../Assets/Images/AboutUs.jpg\") ;\n    background-size: cover;\n    border-radius: 25px;\n    margin: 0 auto;\n  }\n  .logo {\n    background: rgba(255, 255, 255, 0.09);\n    border-radius: 52px;\n    margin: auto;\n    max-width: 400px;\n    text-align: center;\n    padding: 10px;\n\n    img {\n      margin-bottom: 30px;\n    }\n\n    h2,h1 {\n      margin: 0;\n      font-family: 'hemi_head';\n    }\n  }\n\n  .items {\n    position: relative;\n    height: 100%;\n\n    p {\n      background: rgba(255, 255, 255, 0.06);\n      border-radius: 16px;\n      font-family: Roboto;\n      max-width: 400px;\n      padding: 15px;\n    }\n\n    .item1 {\n      position: absolute;\n      top: 10%;\n      left: 10%;\n      @media (max-width: 1200px) {\n       left: 3%;\n      }\n    }\n\n    .item2 {\n      position: absolute;\n      top: 25%;\n      right: 10%;\n      @media (max-width: 1200px) {\n        right: 3%;\n      }\n    }\n\n    .item3 {\n      position: absolute;\n      top: 50%;\n      left: 10%;\n      @media (max-width: 1200px) {\n        left: 3%;\n        top: 40%;\n      }\n    }\n    .item4 {\n      position: absolute;\n      top: 60%;\n      right: 10%;\n      @media (max-width: 1200px) {\n        right: 3%;\n        top: 65%;\n      }\n    }\n  }\n\n  h3 {\n    position: absolute;\n    bottom: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    font-size: 35px;\n    text-align: center;\n    font-family: hemi_head;\n    @media (max-width: 600px) {\n      font-size: 24px;\n      display: none;\n    }\n  }\n}\n.itemBlock{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 80%;\n  min-height: 600px;\n  margin: auto;\n  background: rgba(217, 217, 217, 0.09);\n  box-shadow: 4px 4px 4px rgba(255, 255, 255, 0.25);\n  border-radius: 328px 0px;\n  color: #ffffff;\n  margin-top: 50px;\n  padding: 30px;\n  position: relative;\n  @media (max-width: 700px) {\n    border-radius: 100px 0px;\n  }\n  div{\n    text-align: center;\n    font-family: Roboto;\n    width: 100%;\n    h4{\n      font-family: hemi_head;\n      text-shadow: 3px 3px 4px rgba(255, 255, 255, 0.25), 3px 3px 4px rgba(255, 255, 255, 0.25);\n      font-size: 36px;\n    }\n    .text1{\n      display: flex;\n      width: 100%;\n    }\n    .text2{\n      display: flex;\n      width: 100%;\n      justify-content: space-evenly;\n\n    }\n    p{\n      max-width: 400px;\n    }\n  }\n  .imgBlock{\n    width: auto;\n    position: absolute;\n    top: 0;\n    right: 0;\n    transform: translate(-10%,10%);\n    @media (max-width: 980px) {\n    display: none;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aboutUs": `AboutUs_aboutUs__-5Kcw`,
	"logo": `AboutUs_logo__8qXVy`,
	"items": `AboutUs_items__vVlP+`,
	"item1": `AboutUs_item1__Rucft`,
	"item2": `AboutUs_item2__9xT+Y`,
	"item3": `AboutUs_item3__tdwvP`,
	"item4": `AboutUs_item4__qKVMf`,
	"itemBlock": `AboutUs_itemBlock__G3W8B`,
	"text1": `AboutUs_text1__Rt-Jq`,
	"text2": `AboutUs_text2__KmGGF`,
	"imgBlock": `AboutUs_imgBlock__hkmEu`
};
export default ___CSS_LOADER_EXPORT___;
